import SearchContractsView from './search-contracts-view';

const SearchContracts = () => <SearchContractsView />;

export default SearchContracts;
